'use client'

import React, { FC, ReactElement } from 'react'
import styles from './CreateWalletHeader.module.css'
import classNames from 'classnames'
import ArrowIcon from '@/icons/arrow'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const CreateWalletHeader: FC<{
	step: number
	total: number
	nextDisabled: boolean
	onNext: (evt: any) => void
	onBack?: (evt: any) => void
}> = ({ step, total, nextDisabled, onNext, onBack }): ReactElement => {
	const renderStep = React.useCallback(
		(index: any, _e: any) => (
			<div
				key={index}
				className={classNames(styles.step, {
					[styles.stepCompleted]: step >= index
				})}
			/>
		),
		[step]
	)

	return (
		<div className={styles.root}>
			{step !== 0 && (
				<div
					className={styles.arrowContainer}
					onClick={onBack}
					role="button"
					tabIndex={0}
					onKeyDown={onKeyboardClick(onBack)}
				>
					<ArrowIcon className={styles.arrowIcon} />
				</div>
			)}
			<div className={styles.stepContainer}>{Array.from(Array(total).keys()).map(renderStep)}</div>
			<button
				onClick={onNext}
				disabled={nextDisabled}
				className={classNames(styles.nextButton, {
					[styles.nextButtonDisabled]: nextDisabled
				})}
				type="button"
			>
				<p className={classNames('text-sm', 'semibold')}>Next</p>
			</button>
		</div>
	)
}

export default CreateWalletHeader
